import React from "react";
import IntroSection from "../components/IntroSection";
import SolutionsSection from "../components/SolutionsSection";
import ProductDesignProcess from "../components/ProductDesignProcess";

import ProductionBook from "../components/ProductionBook";
import CustomerTestimonials from "../components/CustomerTestimonials";
import WebflowSection from "../components/WebflowSection";
import StrengthBusiness from "../components/StrengthBusiness";
import PDCertificate from "../components/PDCertificate";
import BlueSectionDivider from "../components/BlueSectionDivider";
import CountriesSection from "../components/CountriesSection";
import PDProjects from "../components/PDProjects";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import WorkingModelSection from "../components/WorkingModelSection";
import TechStackSection from "../components/TechStackSection";
import PDFaq from "../components/PDFaq";
import PDPResources from "../components/PDPResources";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";


const ProductDesign = () =>{
  return(  <div>
<IntroSection title = "PRODUCT DESIGN PROCESS" paragraph = "Integrate an innovative and practical approach that considers your users’ goals." backgroundImage="/images/pdp-bg.webp"/>
<SolutionsSection para1 = "Our expertise covers an array of areas, from simpler projects such as website building to highly complex web based applications." para2 = "Our Product Design Process service provides you with the right tools and resources to guide you through the design of any kind of web-based solution, whether you are a startup looking to develop an MVP, a scale-up looking to improve your product, or an enterprise scaling your website or digital product capabilities."/>
    <ProductDesignProcess/>
    <ProductionBook/>
   
    <WebflowSection/>
    <StrengthBusiness/>
   
    <BlueSectionDivider/>
    <CountriesSection/>
    <PDProjects/>
    <TeamSection/>
    <WhyUsSection/>
    <WorkingModelSection/>
    <TechStackSection/>
    <BlueSectionDivider/>
    <PDFaq/>
 
    <ContactSection backgroundColor="#057af0ff"/>
    <Footer/>
    </div>)
}
export default ProductDesign;